// extracted by mini-css-extract-plugin
module.exports = {"item":"kw","dark":"kx","light":"ky","toggle":"kz"};